@if (action != 'VIEW' && action != 'MODIFY' && additionalSurgeryConfig && patientDetail != undefined &&
patientDetail.serviceType_code == 'surgery' && patientDetail.patientType != 'OP') {
<div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" style="padding-top: 34px;">
  <div class="custom-control ml-4">
    <input type="checkbox" class="custom-control-input" [checked]="additionalSurgeryCheck" id="additionalSurgeryCheck"
      name="additionalSurgeryCheck" (click)="additionalSurgery($event,$event.target.checked)">
    <label class="custom-control-label" for="additionalSurgeryCheck">Additional Surgery</label>
  </div>
</div>
}
@if (action != 'VIEW' && action != 'MODIFY' && otSlots['question'] && patientDetail && patientDetail.serviceType_code ==
'surgery') {
<div class="kx-control col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
  <label for="multipleSurgeryName" id="multipleSurgeryName">Multiple Surgery Name</label>
  <kx-multiselect-dropdown [questions]="otSlots.question" name="multipleSurgeryName" [controlName]=""
    [placeholder]="'Select Surgery'" [data]="otSlots.question?.datasource" [settings]="otSlots.defaultSetting"
    (onDeSelect)="onItemDeSelect($event)" (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)">
  </kx-multiselect-dropdown>
</div>
}

@if (action != 'VIEW' && resourceDef && patientDetail) {
<dhs-form [action]="'ADD'" [data]="patientDetail" [fieldGroup]="resourceDef.form" [config]="configForm"
  [decorator]="decorator" (questionValueChanged)="questionValueChanged($event)">
</dhs-form>
}
@if (action == 'VIEW' && resourceDef && patientDetail) {
<dhs-form-view [fieldGroup]="resourceDef.form" [data]="patientDetail">
</dhs-form-view>
}
@if (action != 'VIEW') {
<div class="row form-primary-actions sticky-add-btn mb-3">
  <div class="col-12 text-center" id="showButtons">
    <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('final')">Submit<i
        class="fa fa-check ml-2" aria-hidden="true"></i></button>
    @if (patientDetail != undefined && action != 'MODIFY' && resourceDef!= undefined && ((patientDetail.request_type ==
    'Surgery' || patientDetail.serviceType == 'Surgery'))) {
    <button class="aside-fixed-button primary-btn submitButton" (click)="saveData('draft')">Draft<i
        class="fa fa-save ml-2" aria-hidden="true"></i></button>
    }
  </div>
</div>
}